/**
 * Roles that count as internal A2Z staff. `client` is the legacy name for
 * `internal` and is retained until the backend token-cycle migration completes.
 */
export const INTERNAL_ROLES = ["admin", "client", "internal"] as const;

/** True when the role is internal A2Z staff (full data access on the backend).
 * Derives membership from INTERNAL_ROLES so the two cannot drift. */
export const isInternalRole = (userType: string | null | undefined): boolean =>
  userType != null && (INTERNAL_ROLES as readonly string[]).includes(userType);

/** True for a demo viewer: someone outside a2z shown a device panel, who sees
 * the panel pages only (no worklist, labeling or screen recording). */
export const isDemoViewer = (userType: string | null | undefined): boolean =>
  userType === "demo_viewer";
